module.exports = __webpack_public_path__ + "static/media/06.d0ffe5f4.jpg";